<div class="claim-container" *ngIf="isInsuranceClaimVisilble">
  <span class="col-12 title-header ">
    <div class="col-10 title-header pl-0">
      <span class="shield-icon"></span>
      <span class="title">Package Protection with InsureShield<sup>&reg;</sup></span>
    </div>
    <div class="col-2 pr-0">
      <div class=" active-pill">Active</div>
    </div>
    </span>

  <div class="col-12">
    <div class="purchase-protection"><div class="shield-tick-icon"></div>Your purchase is protected</div>
  </div>
  <div class="col-12 coverage-container">
    <div class="coverage-icon">
    </div>
    <div>
      <div class="coverage-title">Comprehensive Coverage</div>
      <div class="coverage-desc">Get coverage up to the invoice value plus shipping for loss, damage, and porch piracy.
      </div>
    </div>
  </div>
  <div class="col-12 coverage-container">
    <div class="coverage-icon">
    </div>
    <div>
      <div class="coverage-title">Full Protection</div>
      <div class="coverage-desc">Protect domestic and international inbound, outbound, freight collect, and third-party
        shipments.
      </div>
    </div>
  </div>
  <div class="col-12 coverage-container">
    <div class="coverage-icon">
    </div>
    <div>
      <div class="coverage-title">Fast Claims</div>
      <div class="coverage-desc">Receive quick claims payments in days, not weeks, and keep your cash flowing.
      </div>
    </div>
  </div>
  <div class="row claim-btn-container">
    <div class="col-12">
      <a [href]="insuranceClaimUrl" target="_blank" class="claim-btn">
        <div class="clipboard-icon"></div>File a Claim
      </a>
    </div>
  </div>
</div>
